module.exports = __webpack_public_path__ + "img/logo_acs.c9222609.png";